import React from 'react';
import PropTypes from 'prop-types';
import {Button, Card, Divider, Tag} from 'antd';
import ChatInputTextarea from './ChatInputTextarea';
import {ClockIcon, DeleteIcon, EditIcon, PauseIcon, PlayIcon} from '@web/assets/icons';
import UserAvatar from './UserAvatar';
import RunAppButton from '@clients/app-builder/components/RunAppButton';
import Icon from './Icon';
import ListItemMeta from '@web/ui/components/ListItemMeta';
import ActiveWorkflowCard from './ActiveWorkflowCard';
import {formatField} from '@web/lib/formaters';
import {removeJob, updateJob} from '@web/lib/workflow.jobs';
import {Fields, getDocRef} from '@web/lib/firestore.db';
import {notifyAndTrack} from './notification';
import now from 'lodash/now';

JobCard.propTypes = {
  job: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
  preview: PropTypes.bool,
  onSelect: PropTypes.func,
};

function JobCard(props) {
  const [instructions, setInstructions] = React.useState("");
  const [editing, setEditing] = React.useState(false);

  const onSaveInstructions = () => {
    updateJob(getDocRef(props.path), {instructions})
    .catch((error) => {
      notifyAndTrack.error("Error updating job");
    });
  }

  const onDelete = () => {
    removeJob(getDocRef(props.path))
    .catch((error) => {
      console.log("Error creating job", error);
      notifyAndTrack.error("Error removing job");
    });
  }

  const onPause = () => {
    const pre = props.job.paused;
    updateJob(getDocRef(props.path), {
      paused: props.job.paused ?
        Fields.deleteField() :
        now(),
    })
    .then(() =>
      notifyAndTrack.success(pre ? "un paused" : "paused"))
    .catch((error) => {
      notifyAndTrack.error("Error updating job");
    });
  }

  if (!props.job) {
    return null;
  }

  if (props.preview && !editing) {
    return <Card
      onClick={() => props.onSelect?.(props.path, props.job)}
      className="card-simple card-rounded card-slim-title"
      style={{width: "100%"}}
      bordered={false}
    >
      <ListItemMeta
        key={props.path}
        data={{
          title: ["Run ", props.job?.workflow?.name],
          description: ["Every time a new record is created ", props.job?.workflow?.description],
          icon: props.job?.workflow?.icon || props.job?.icon,
        }}
        actions={[
          props.job?.paused ?
            <Button key="pause-btn" shape="round" onClick={onPause} className="icon-btn orange-color">
              Paused
            </Button> :
            <Button key="pause-btn" shape="round" onClick={onPause} className="icon-btn orange-color">
              Active
            </Button>,
          <Divider type="vertical" className="hidden" />,
          <Button shape="circle">
            <Icon className="orange-color" name="TbCalendar" />
          </Button>,
          <Button key="edit-btn" shape="circle" onClick={() => setEditing(!editing)}>
            <EditIcon className="orange-color" />
          </Button>,
          <Button shape="circle" onClick={onDelete}>
            <DeleteIcon className="orange-color" />
          </Button>,
        ]}
      />
    </Card>
  }

  return <section>
    <Card
      title="App"
      className="card-simple card-rounded"
      bordered={false}
      extra={
        <div className="space space-center-y gap-8">
          <RunAppButton workflowPath={props.job?.workflowPath} jobPath={props.path} size="normal" />
          <Button shape="circle" onClick={onPause}>{props.job?.paused ? <PlayIcon className="orange-color" /> : <PauseIcon />}</Button>
          <Button shape="circle" onClick={onDelete}><DeleteIcon className="orange-color" /></Button>
          <Button shape="circle" onClick={() => setEditing(!editing)}><EditIcon className="orange-color" /></Button>
        </div>
      }
    >
      <br/>
      <Card.Meta
        description={
        <div>
          <Tag className="font-lg rounded" color="yellow">{props.job?.event}</Tag>{formatField("source", props.job?.source)}
        </div>
        }
        avatar={<UserAvatar icon={<Icon name={props.job.icon || "ClockIcon"} />} />}
        title={props.job?.description}
      />
      <br/>
      <br/>
      <ChatInputTextarea
        onTextChange={setInstructions}
        onPressEnter={onSaveInstructions}
        dictate={false}
        placeholder={instructions || props.job?.instructions || 'Enter any start instructions here or context here'}
        ai
      />
      <Divider />
      <ActiveWorkflowCard collapsed path={props.job.workflowPath} workflow={props.job.workflow} />
    </Card>
  </section>;
}

export default JobCard;
